import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/settings/billing")({
  component: lazyRouteComponent(() => import("./+BillingSettings")),
  head: () => ({ meta: seo({ title: "Billing Settings" }) }),
});
